import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const LoadingContext = createContext(null);

// Counter-based rather than a plain boolean: several fetches can be in
// flight at once (e.g. ByService's compare mode fires two calls, or a user
// expands two service rows back to back). The bar should only disappear
// once every one of them has finished, not just the first.
export function LoadingProvider({ children }) {
  const [count, setCount] = useState(0);

  const start = useCallback(() => setCount((c) => c + 1), []);
  const stop = useCallback(() => setCount((c) => Math.max(0, c - 1)), []);

  const value = useMemo(() => ({ active: count > 0, start, stop }), [count, start, stop]);

  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
}

// Returns { active, start, stop }. Call start() right before firing a
// request and stop() in a .finally()/finally block once it settles —
// always in pairs, so the counter can't get stuck above zero.
export function useLoading() {
  const ctx = useContext(LoadingContext);
  if (!ctx) throw new Error("useLoading must be used within a LoadingProvider");
  return ctx;
}
